/** Search parameters used in the Konsole user page. */
export const searchParametersKonsoleUser = {
    FIRST_NAME: 'first_name',
    ADMIN: 'is_admin',
    LAST_NAME: 'last_name',
    MANAGERS: 'managers',
}

/** Search parameters used in the Konsole user API. */
export const searchParametersKonsoleUserApi = {
    FIRST_NAME: 'first_name__icontains',
    ADMIN: 'is_staff',
    LAST_NAME: 'last_name__icontains',
    MANAGERS: 'profil__client__in',
}
